export default {
  Andpenalties: 'Likviderade skadestånd och påföljder',
  DeliveryFailed: 'Leveransen misslyckades, återbetalningen bärs av part A',
  abandonedRequests: 'Övergiven ordning',
  abandonedorder: 'Övergiven ordning',
  accesshelpcenter: 'Gå till vårt hjälpcenter',
  accessoriesLessDelivery:
    'Brist på tillbehör, mindre leverans, återbetalningar står Part A för',
  accesstoken: 'Access Token',
  accessurlexample: 'Exempel: din-butik.com',
  accessurlprefix:
    'URL:en får inte innehålla följande värden: www., https://, http://, /',
  actions: 'Åtgärder',
  activate: 'aktivera',
  activateStore:
    'Om du ska använda vår onlinebutik, aktivera den för att släppa alla DNS-poster.',
  active: 'AKTIV',
  active2: 'Aktiv',
  actuallyPrice: 'Faktiskt pris',
  addDomainTips1: 'Länka en domän som redan tillhör dig.',
  addDomainTips2:
    'Du kan också länka en underdomän. Se till att starta ditt formulär med "betala" eller "pago". Ex.:',
  addDomainTips3: 'Använd inte',
  addDomainTips4: 'Håll utkik! för att din domän ska fungera,',
  addDomainTips5: 'du måste köpa och ställa in den med en värdtjänst',
  addDomainTips6: 'eller annan.',
  addDomainTips7: 'Om du har några frågor, kontakta vår',
  addPopup: 'Lägg till kupong',
  addastore: 'Lägg till en butik',
  addstore: 'Lägg till butik',
  afterEachSuccessful:
    'Efter varje framgångsrik transaktion av Part B kommer Part A att ta ut 5 % av det framgångsrika transaktionsbeloppet för Part B, och behålla den revolverande marginalen på Part A:s konto samtidigt som den överförs till Part B. Den revolverande marginalen på Part A:s konto för varje transaktion kommer att behållas i 45 dagar, och beloppet kommer att frigöras till Part B efter 45 dagar.',
  afterSales:
    'Det här är postlådan efter försäljningen. Kunder skickar eftermarknadsfrågor till den här brevlådan, och eftermarknadsteamet kommer att svara.',
  afterVerification:
    'Om skälet till återbetalning hamnar i följande fem situationer efter verifiering, kommer återbetalningen att bäras av part B',
  agreetoNY: '"Genom att skapa ett konto godkänner du USAdrops"',
  alreadyhaveanaccount: 'Har du redan ett konto?',
  and: 'och',
  apikey: 'API-nyckel/klient-ID',
  apisecretkey: 'API hemlig nyckel / hemlig',
  ativo: 'AKTIV',
  backgroundColor: 'Bakgrundsfärg',
  basicinformation: 'Grundläggande information',
  blacklisted:
    'Om kunden är svartlistad ska återbetalningen annulleras och bäras av Part B',
  blacklistedCustomer: 'Svartlistad kund, avbryt återbetalning',
  borneByParty:
    'På grund av Part B:s underlåtenhet att betala i tid, begär kunden att avbryta beställningen och återbetalningen ska bäras av Part B',
  borneParty:
    'Om produkten inte är tillfredsställande (inte gillar den) ska återbetalningen stå för part A',
  buttonText: 'Knapptext',
  cancel: 'avboka',
  cancellationAnd:
    'Om beställningen inte skickas och kunden begär avbeställning och återbetalning, ska återbetalningen stå för part B',
  cardPaymentsAnswer:
    'När kunden betalar in på vårt konto kommer det att överföras till din plånbok nästa dag.',
  cardPaymentsTitile:
    'Hur lång tid tar det för beloppet att överföras till mitt konto efter att kunder har lagt beställningar?',
  carddesc: 'KORT,BOLETO, BANKINSÄTTNING OCH PIX',
  changeAddress:
    'För begäran om adressändring efter att varorna har skickats ska återbetalningen stå för part B',
  classic: 'Klassisk',
  collaboratorRequestCode:
    'Butikssamarbetsbehörigheter och koder (Vår e-post är _email_, vänligen bearbeta behörigheten)',
  collapsemenu: 'Komprimera menyn',
  confirm: 'Bekräfta',
  confirmedAndThe:
    'Om beställningen ska bekräftas och kunden inte svarar på mer än 2 dagar, ska återbetalningen stå för part B',
  confirmpassword: 'Bekräfta ditt lösenord',
  contentTerms: 'Innehållsvillkor',
  convertedOrderPaid: 'Konverterad beställning (betald)',
  convertedOrderUnpaid: 'Konverterad beställning (obetald)',
  copy: 'kopiera',
  correspondingPenalties:
    'Part B ska följa lagar och regler samt Part A och kortorganisationens riskhanteringskrav för olagliga transaktioner. Om Part B bryter mot någon av dessa regler, kommer Part B att bli föremål för motsvarande straff och böter.',
  countdownImage: 'Nedräkningsbild',
  countdownTimer: 'Nedräkningstimer',
  countdownBg: 'Nedräkning Bakgrundsfärg',
  countdownTextColor: 'Nedräkning TextColor',
  country: 'Land',
  coupon: 'Kupong',
  couponCode: 'Rabattkod (valfritt)',
  creatanaccount: 'Skapa ett konto',
  createTime: 'Skapa tid',
  createaccounttitle:
    'Skapa ditt gratiskonto på vår grundplan, utan månadsavgifter.',
  createfreeaccount: 'Skapa ett gratis konto',
  createpassword: 'Skapa ett lösenord',
  currencyConversionAnswer:
    'Konvertera baserat på den officiella växelkursen som tillhandahålls av betalningsleverantören',
  currencyConversionTitle: 'Valutaomvandlingsproblem?',
  currentStoreName: 'Nuvarande butik:',
  customerBuysMore:
    'Om kunden köper mer och vill ångra och återbetala, ska återbetalningen stå för part B',
  date: 'Datum',
  days: 'dagar',
  defaultDomainTips:
    '"Detta är den kostnadsfria domänen från USAdrop. Den kommer alltid att fungera. Men vi indikerar att du skapar din egen."',
  delete: 'Radera',
  deleteSelected: 'RADERA VALT',
  deleteSuccess: 'Raderingen lyckades!',
  deletedSuccessfully: 'Raderades framgångsrikt',
  deliveryTime:
    'Kunden tar emot varorna, leveranstiden är för lång, överskrider butikens tidsgräns, återbetalningar står Part A för',
  disable: 'Inaktivera',
  disabledSuccessfully: 'Inaktiverad framgångsrikt',
  discount: 'Rabatt',
  discountAmount: 'Rabattbelopp',
  discountPercent: 'Rabatt i procent',
  discountRate: 'Rabattinställningar',
  dnsNormal: 'DNS-postkonfigurationen är normal',
  dnsNotConfigured: 'DNS-posten är inte konfigurerad eller sprids inte.',
  dnsRecordsTitle: 'DNS-poster för din onlinebutik',
  domain: 'Domän',
  domainbtntext: 'Inrätta',
  domaintitle: 'Konfigurera samma domän som din Shopify-butik här.',
  eachSuccessfulTransaction:
    'Efter varje framgångsrik transaktion av Part B kommer Part A att ta ut 10 % av det framgångsrika transaktionsbeloppet för Part B, och behålla den revolverande marginalen på Part A:s konto samtidigt som den överförs till Part B. Den revolverande marginalen på Part A:s konto för varje transaktion kommer att behållas i 45 dagar, och beloppet kommer att frigöras till Part B efter 90 dagar.',
  edit: 'Redigera',
  editstore: 'Redigera butik',
  email: 'E-post',
  emailContent: 'E-postinnehåll',
  emailReminders: 'Kampanjinställning',
  emailRemindersDesc: 'Ställ in e-postpåminnelser och beställningsrabatter',
  emailTemplateConfig: 'Konfiguration av e-postmall',
  emailTemplateConfigDesc: 'Anpassat e-postinnehåll',
  emailTitle: 'E-postämne',
  embedPaymentMethods:
    'Använd e-postmeddelanden för att uppmana kunder att slutföra betalningen vid olika tidpunkter för att öka orderomvandlingsfrekvensen.',
  emptyCouponDesc:
    'Efter att ha konfigurerat kupongen, kommer en popup för att göra anspråk på kupongen att visas efter att betalningen har slutförts, vilket uppmuntrar användaren att använda kupongen för en bättre affär.',
  emptyCouponTitle: 'Konfigurera din kupong',
  enable: 'Aktivera',
  enableCouponTips:
    'Endast en kupong kan vara aktiv åt gången. Inaktivera andra kuponger innan du fortsätter!',
  enabledSuccessfully: 'Aktiverades framgångsrikt',
  end: 'Avsluta',
  endDate: 'Slutdatum',
  enter: 'Skriva in',
  entercorrectemail: 'Vänligen ange rätt e-postformat',
  enteremailandpassword: 'Ange din e-postadress och ditt lösenord',
  example: 'Exempel',
  faqs: 'Vanliga frågor',
  firstPaymentChannel: 'Betalningsmetod för första beställning',
  firsttimeaNY: 'Första gången på USAdrop?',
  followInstructions: 'Följ instruktionerna',
  followingPenalties:
    'Utöver de ovan nämnda böterna kommer de som allvarligt bryter mot bestämmelserna att dömas till följande påföljder:',
  forBrazil: 'För Brasilien:',
  forMexico: 'För Mexiko/Chile/Colombia/Peru:',
  forPaymentFailure:
    'Vid utebliven betalning ska återbetalningen bäras av part B',
  forShopify:
    'När du registrerar dig för Shopify får din webbutik en "myshopify.com"-URL.',
  forgetpassword: 'Jag glömmer mitt lösenord',
  fullname: 'Fullständigt namn',
  goodsNum: 'föremål',
  gtm: 'Kod (GTM-XXXXXXX)',
  gtmRequired: 'Behållar-ID krävs',
  gtmDomain: 'Serverbehållarens URL',
  gtmDomainRequired: 'Serverbehållarens URL krävs',
  googleid: 'Mät-ID',
  googlekey: 'Measurement Protocol API-hemligheter',
  googleidRequired: 'Mät-ID krävs',
  googlekeyRequired: 'Measurement Protocol API-hemligheter krävs',
  hasBeenSigned:
    'Logistik visar att den är undertecknad, men kunden har inte fått den, återbetalningar står Part A',
  hasquestions: 'Har du frågor?',
  headerImage: 'Header Bild',
  helpCenter: 'Hjälpcenter',
  helpaddress: 'bento.me/enchentesrs',
  hi: 'Hej',
  holding: '1, Hålla',
  home: 'Hem',
  howtocontribute: 'Se hur du bidrar på',
  howtoset: 'Hur man ställer in',
  identifyyourself: 'Identifiera dig själv',
  imitationBrand: 'Imitation/imitation varumärke',
  inActive: 'INAKTIV',
  inativo: 'INATIVO',
  info: 'Information',
  installtitle: 'Installera USAdrop Transparent Checkout i din Shopify-butik.',
  invitationNumber: 'Inbjudningskod',
  invitationNumberError:
    'Ange ditt inbjudningsnummer för att slutföra din registrering',
  isConfirmDelete: 'Är du säker på att du vill ta bort den?',
  kEmail: 'E-post',
  kName: 'Namn',
  learnMore: 'lär dig mer.',
  lengthLimit: 'Längden ska vara 3 till 8',
  letteringPattern:
    'Produktkvalitet (storlek, färgskillnad, skador, fläckar, trådändar, lukt, rynkor, blekning, krympning, bokstäver, mönster, logotyp, tillbehör), återbetalningar bärs av part A',
  like: 'som',
  linkNewDomain: 'Länka ny domän',
  liquidatedDamages: 'Likviderade skadestånd och påföljder.',
  logaccount: 'Du är inloggad på:',
  loginsuccess: 'inloggning lyckad!',
  logout: 'Utloggning',
  logoutSYS: 'Om man ska logga ut från systemet?',
  lougoutsuccess: 'Logga ut framgång!',
  markAsActive: 'Markera som aktiv',
  markAsInactive: 'Markera som inaktiv',
  min: 'min',
  mydomain: 'Min domän',
  mydomains: 'Mina domäner',
  mydomainsdesc:
    'Hantera dina domäner här. Länka dina domäner och konfigurera dem så att de är den virtuella adressen till din butik och kassan.',
  name: 'NAMN:',
  needhelp: 'Rio Grande do Sul behöver din hjälp.',
  newaffiliations: 'Nytt land',
  newpixel: 'Ny pixel',
  nextPage: 'Nästa sida',
  backToMessages: 'Tillbaka till meddelanden',
  messageDetail: 'Meddelandedetaljer',
  noNotifications: 'Inga aviseringar',
  notifications: 'Aviseringar',
  refresh: 'Uppdatera',
  no: 'Inga',
  noDomain: 'Ingen domän',
  noStatus: 'Ingen status',
  noUseDefaultDomain: 'Använd inte USAdrops standardbetaldomän!',
  noUseOrgin: 'Använd inte http:// https:// och www',
  nocountriesavailable: 'Inga länder tillgängliga',
  nodatareadtitle: 'Läs hela vår artikel',
  nodatastartsell: 'När du börjar sälja visas dina beställningar här.',
  nodatatip1: 'Anpassa din butik med utseendet på ditt företag!',
  nodatatip2: 'Erbjud olika betalningsmetoder.',
  nodatatip3: 'Lägg till bra bilder till dina produkter.',
  nodatatip4:
    'Gör dina produktbeskrivningar attraktiva och använd SEO-tekniker.',
  nodatatip5:
    'Investera i betald trafik: annonser på sociala nätverk och Google shopping.',
  nodatatip6: 'Se om priset på dina produkter är attraktivt.',
  nodatatip7: 'Ha en kundtjänstkanal för att svara på frågor',
  nodatatips: '7 snabba tips för att göra din första försäljning:',
  nodatatitle: 'Det finns inga beställningar att visa än',
  nodeDescription: 'Utlösande situationsbeskrivning',
  nodeName: 'Utlösande situation',
  operation: 'Status',
  order: 'Beställa',
  orderCancel: 'Avbruten',
  orderClosed: 'Stängd',
  orderConversion: 'Orderstatus',
  orderConversionTipUnpaid:
    'Återvunnen genom remarketing, men fortfarande obetald.',
  orderConversionTipUnconverted: 'Kunden genomförde aldrig betalningen.',
  orderConversionTipPaid:
    'Återvunnen genom remarketing och betalad.',
  orderConversionTipPending:
    'Kunden påbörjade betalningen men slutförde den inte.',
  orderConversionTipPaidStatus: 'Betalningen har slutförts.',
  orderDeliver: 'Leverera',
  orderEnd: 'Avslutad',
  orderPaid: 'Betalt',
  orderReceived: 'Levereras',
  orderToAnalyze:
    'För att kunna analysera källorna till olika beställningar och justera annonserna i tid är vår data mer korrekt än den på Facebook.',
  orderWaitPay: 'I avvaktan på',
  ordernum: 'Beställningsnr',
  more: 'Mer',
  orderCodesBatchTips:
    'Ange ett beställningsnr per rad, eller separera med kommatecken',
  ordertime: 'Beställningstid',
  originurl: 'Webbplatsadress',
  originurlexample: 'Exempel: din-butik.myshopify.com',
  originurlprefix:
    'URL:en får inte innehålla följande värden: www., https://, http://, /, .br',
  package:
    'Om kunden vägrar att acceptera paketet och begär återbetalning, ska återbetalningen stå för part B',
  partyAProvides:
    'Part A tillhandahåller en återbetalningsgarantitjänst för kooperativa beställningar till en avgift på 1,5 %. Om orsaken till återbetalningen verifieras vara att kunden är missnöjd med produkten efter att ha mottagit den, kommer återbetalningsavgiften att bäras av Part A och Part B behöver inte bära de relaterade förlusterna. För specifika användningsscenarier, se bilagan till systemavtalet.',
  partyAProvidesconsumers:
    'För att säkerställa betalningsstabilitet och efterlevnad ska Part A vara den enda leverantören av eftermarknadstjänster åt Part B. Part B ska fullt ut bemyndiga Part A att hantera alla eftermarknadsärenden och ge tillgång till relevanta e-postkonton. Eventuell efterförsäljning från Part B är exceptionell och kräver Part A:s förhandsgodkännande, och i sådana fall ska Part B ge Part A full tillgång till relevanta e-postkonton för efterförsäljning för realtidsövervakning. Brott mot denna klausul ger Part A rätt att omedelbart avbryta eller avsluta B:s tillgång till betaltjänster utan ansvar.',
  partyProvides:
    'Part A förser Part B med gränsöverskridande internetbetalnings- och avvecklingstjänster, inklusive:',
  password: 'Lösenord',
  payBy: 'BETALA MED',
  payment: 'Betalning',
  paymentDateAnswer:
    'Du kan ansöka om uttag efter att ha betalat ordergenomförandeavgiften. Uttaget kommer vanligtvis att behandlas inom 1-2 arbetsdagar. Den slutliga ankomsttiden beror på din bank.',
  paymentDateTitle:
    'Hur lång tid tar det innan uttaget tas emot efter att jag påbörjat det?',
  paymentDomain: 'Domän CNAME Resolve',
  paymentRatesTitle: 'Betalning och priser för varje land',
  paymentServicesToParty:
    'Part A tillhandahåller betaltjänster till Part B och Part B behöver informera Part A om butikens inloggningsuppgifter. Part A förser också Part B med relevant transaktionsinformation och frågetjänster för avvecklingsinformation, och Part B behöver samarbeta med Part A för att gemensamt upprätthålla stabiliteten på betalproduktkontot.',
  paymentSetting: 'Betalningsinställningar',
  paymentTime: 'Betalningstid',
  paymentaffiliations: 'Betalningsinställningar',
  paymentaffiliationsdesc:
    'Inställningarna för att genomföra transaktioner i din butik, och språk- och landsinställningarna för gränssnittet som visas för kunderna',
  shopifyCurrencyConfirmBRL:
    'Bekräfta att valutan i din Shopify-butik är inställd på BRL.',
  shopifyCurrencyConfirmCLP:
    'Bekräfta att valutan i din Shopify-butik är inställd på CLP.',
  shopifyCurrencyConfirmCOP:
    'Bekräfta att valutan i din Shopify-butik är inställd på COP.',
  shopifyCurrencyConfirmEUR:
    'Bekräfta att valutan i din Shopify-butik är inställd på EUR.',
  shopifyCurrencyConfirmGBP:
    'Bekräfta att valutan i din Shopify-butik är inställd på GBP.',
  shopifyCurrencyConfirmMXN:
    'Bekräfta att valutan i din Shopify-butik är inställd på MXN.',
  shopifyCurrencyConfirmPEN:
    'Bekräfta att valutan i din Shopify-butik är inställd på PEN.',
  shopifyCurrencyConfirmSEK:
    'Bekräfta att valutan i din Shopify-butik är inställd på SEK.',
  shopifyDomainUsedByOtherStore:
    'Denna domän har använts av en annan Shopify-butik. Ändra status för alla oanvända Shopify-butiker till "Inactive".',
  confirmStoreConnectedWiio:
    'Bekräfta att din butik är ansluten till Wiio Dropshipping.',
  confirmStoreConnectedUsaDrop:
    'Bekräfta att din butik är ansluten till USADrop Dropshipping.',
  paymentbtntext: 'Att ställa in',
  paymentdoamin: 'Domän CNAME Resolve',
  paymentlanguage: 'Språk för kassasidan',
  paymentoptions: 'Betalningsalternativ',
  paymentoptionsdesc: 'Betalningsalternativen som accepteras i din butik.',
  paymenttitle: 'Konfigurera de betalningsmetoder som accepteras i din butik.',
  personalInformationVerification: 'Verifiering av personlig information',
  personalInformationVerificationSubTitle:
    'Informationsverifiering involverar ditt mobiltelefonnummer.',
  phone: 'Telefonnummer',
  pixel: 'Pixel',
  pixelIDisRequired: 'Pixel-ID krävs',
  pixelTokenisRequired: 'Pixel Token krävs',
  pixelexample:
    'Exempel: En kund ser din annons, besöker din webbplats och gör ett köp. Pixel spårar detta och hjälper dig att veta vilka annonser som ger störst försäljning.',
  pixelhelp:
    'Analysera resultatet av dina marknadsföringskampanjer och se hur dina kunder interagerar med dina annonser och din butik.',
  pixelid: 'Pixel lD',
  pixelname: 'Pixelnamn',
  pixeltoken: 'Pixel-token',
  platforms: 'PLATTFORMAR',
  pleaseFillTheRequiredFields: 'Fyll i de obligatoriska fälten',
  pleaseInput: 'Vänligen ange',
  pleaseInputDomain: 'Vänligen ange domän',
  pleaseSelect: 'Vänligen välj',
  pleaseSelectDate: 'Välj ett datum',
  pleconfirmPWD: 'Vänligen bekräfta lösenordet',
  pleinputPWD: 'Vänligen ange lösenord',
  popup: 'Popup',
  popupBackground: 'Popup bakgrund',
  popupConfig: 'Popup-konfiguration',
  popupConfigDesc: 'Popup-visningseffekt och popup-regler',
  popupCycle: 'Popup-cykel',
  popupCycleItem: 'Förstagångsanvändare, popup-fönster var {input} dag',
  preview: 'Förhandsvisning',
  previousPage: 'Föregående sida',
  priceTerms: 'Prisvillkor',
  privacypolicy: 'Sekretesspolicy',
  processingTime:
    'Part A kommer att utföra alla beställningar från Part B:s butik och uppdatera handläggningstid, leveranstid, produktbeskrivningar i Part B:s butik etc. enligt Part A:s krav. Om det finns justeringsartiklar, såsom slutprodukter och liknande produkter, bör Part B slutföra justeringen/borttagningen inom 12 timmar.',
  product: 'Produkt',
  productSpecifications:
    'Fel produkt, färg, storlek, annan SPU, specifikationer, återbetalningar bärs av part A',
  productsImitation:
    'Imitationsprodukter_imitationsmärken, återbetalningen ska bäras av part B',
  propertyRights:
    'Det är förbjudet att ladda upp och sälja produkter som gör intrång i immateriella rättigheter',
  protocolBtnPrefix: 'Jag håller med om',
  protocolBtnTitle: 'Betalningsvillkor och sekretesspolicy',
  protocolDialog: 'Användaravtal',
  questionsSupport:
    'Om du har några frågor, använd vårt supportmaterial nedan:',
  recommendSize: 'Rekommenderad storlek: {input}',
  recoverpassowrd: 'Återställ lösenord',
  recovertitle: 'Ange din e-postadress nedan',
  rectifiedAccording:
    'För återbetalning av beställningar som inte korrigeras enligt Part A:s krav ska återbetalningen stå för Part B',
  redirectLink: 'Omdirigera länk',
  refundGuaranteeFees: 'Återbetalningsgarantiavgifter',
  refundGuaranteeTerms: 'Villkor för återbetalningsgaranti',
  refundShallBe:
    'Om produkten inte granskas och produkten är slut i lager, ska återbetalningen stå för part B',
  refundsAreBorne:
    'Logistikinformation visar att den inte har levererats/uppdaterats på länge, återbetalningar står Part A för',
  refundsAreGiven:
    'Produkten har granskats, produkten är slut i lager och återbetalningar ges till kunden, återbetalningar bärs av Part A',
  register: 'Register',
  registersuccess: 'Registrera framgång!',
  registertips:
    'Vi kommer att använda dina uppgifter för att skapa ditt åtkomstkonto och skicka information som hjälper dig att aktivera din butik.',
  requestNumber: 'BESTÄLLNINGSNUMMER',
  requests: 'Beställa',
  requestsCancellation:
    'Beställningen har inte skickats och kunden begär avbeställning',
  save: 'Spara',
  saveFields: 'När du har fyllt i fälten sparar du det du har fyllt i.',
  saveSuccessfully: 'Spara framgångsrikt',
  search: 'Söka',
  secondarydomains: 'Sekundära domäner',
  selectCountry: 'Välj Land',
  selectTimeZone: 'Välj Tidszon',
  service: 'Service',
  serviceemail: 'E-post till kundtjänst',
  setUpDomain:
    'Konfigurera din domän med din leverantör genom att följa stegen nedan.',
  settings: 'Inställningar',
  settlementPeriod:
    'Förlänga avvecklingsperioden eller avbryta avvecklingen; Part A har rätt att säga upp Avtalet och inte återlämna det till Part B. Det oreglerade beloppet och depositionen kommer att regleras vid en annan överenskommen tidpunkt efter sex månader.',
  shipped:
    'Beställningstiden är mindre än eller lika med 3 dagar, beställningen har skickats, och kunden begär att avbryta och återbetala, och återbetalningen ska bäras av Part B',
  shopify: 'Shopify',
  shopifybtntext: 'Installera',
  shopifytitle: 'Installera Transparent Checkout i din Shopify-butik.',
  skipshoppingcart: 'Hoppa över varukorgen',
  specificRates: '3, Specifika priser',
  specificUsageScenarios:
    'Återbetalningar som genereras med andra metoder kommer att bäras av part A. För specifika användningsscenarier, klicka här för att',
  sslCertificate: 'SSL-CERTIFIKAT',
  start: 'Start',
  startDate: 'Startdatum',
  startUsing: 'Aktiv',
  startconfig: 'Börja konfigurera här',
  status: 'Status',
  step1Content:
    '"Gå till din domänleverantörs webbplats. Leta efter avsnittet för konfiguration av DNS-poster."',
  step1Title: '"STEG 1: ÅTKOMST DIN LEVERANTÖRS PANEL"',
  step2Content:
    'I din leverantör, i avsnittet DNS-postkonfiguration, lägg till informationen nedan. Fyll i varje fält med respektive information nedan:',
  step2Title: '"STEG 2: ÅTKOMST DIN LEVERANTÖRS PANEL"',
  step3Content:
    'Efter att ha fyllt i ovanstående uppgifter korrekt med din domänleverantör måste du vänta ett tag tills informationen sprids. Denna process tar vanligtvis upp till 4 timmar.',
  step3Title: 'STEG 3: VÄNTA PÅ FÖRBUD',
  storeAccessingUrl: 'Webbutikens adress',
  storeBinding: 'Anslut butik',
  storeBindingSettings: 'Butiksinställningar',
  storeLogo: 'Butikslogotyp',
  checkoutLogoSizeTip: 'Rekommenderad storlek för logotypen: 230 × 50 px',
  storeLogoLimitTips: 'Rekommenderad storlek: 230*50, inom 200 KB',
  orderImage: 'Butiksordervolym - Senaste 30 dagarna',
  orderRemark: 'Orderanmärkning',
  orderImageLimitTips: 'Flera bilder stöds',
  viewExample: 'Visa exempel',
  storename: 'Butiksnamn',
  termsofuse: 'användarvillkor',
  theCheckoutPage:
    'Rabattbelopp/procent: På kassasidan ställer du in ett fast rabattbelopp/procent för att locka kunder att välja denna betalningsmetod.',
  theProductsSold:
    'Produkterna som säljs på webbplatsen inkluderar produkter som inte är auktoriserade av varumärket eller använder varumärken som inte är auktoriserade av varumärket, samt andra varumärkesprodukter; intrång i icke-varumärkes immateriella rättigheter, inklusive men inte begränsat till: filmer, videor, låtar, spel, animationsverk och deras kringprodukter, inklusive men inte begränsat till figurer, tillbehör och karaktärsutrustning.',
  theRefundShall:
    'Om kunden tar emot varorna och leveranstiden är för lång och den inte överskrider butikstiden, ska återbetalningen stå för part B',
  timezone: 'Tidszon',
  tips: 'Tips',
  toEmbedPaymentMethods: 'För att bädda in betalningsmetoder.',
  toenter: 'Att gå in',
  tosave: 'Att spara',
  total: 'Total',
  trackingNumber: 'Spårningsnummer',
  transactionSettlement:
    'Part B samtycker till att Part A kommer att dra av ovanstående avgifter från Part B:s transaktionsbelopp.',
  transferPlatform: 'Order Transfer Platform',
  tutorial: 'Handledning',
  type: 'TYP:',
  typeofintegration: 'Typ av integration',
  typepassword: 'Skriv ditt lösenord',
  unauthorized:
    'För obehöriga transaktioner ska återbetalningen stå för part B',
  unauthorizedTransaction: 'Otillåten transaktion',
  unconvertedOrder: 'Okonverterad ordning',
  update: 'Att uppdatera',
  urlDisplayed:
    'URL:en som visas i webbläsaren när kunder surfar på din webbutik är ett anpassat domännamn.',
  usedNormally: 'Kan inte användas normalt, återbetalningar bärs av part A',
  value: 'VÄRDE:',
  wantsToCancel: 'Kunden köper mer och vill avboka och återbetala',
  whatisapixel: 'Vad är en Pixel?',
  whatsAppTemplate: 'WhatsApp-mall',
  whichTimeZoneSetTitle: 'Vilken tidszon ska ställas in?',
  withdrawalFeeAnswer:
    'Det beror på din bankavgift. Olika banker har olika avgifter.',
  withdrawalFeeTitle: 'Vilka är avgifterna för uttag?',
  withdrawalMethodAnswer:
    'Efter att ha betalat fullgörandekostnaden kan du ta ut saldot i plånboken. Banköverföring och Paypal-uttag stöds.',
  withdrawalMethodTitle: 'Hur tar man ut pengar och vilka är uttagsmetoderna?',
  yes: 'Ja',
  mismatched: 'Parti B',
  mustNotSell: 'får inte sälja några märkesvaror,',
  brandIconsMust:
    'och varumärkesikoner får inte förekomma i produktbeskrivningar. När Part A upptäcker att det finns en olaglig eller oöverensstämmande varumärkesprodukt i Part B:s butik, kommer Part A att stänga av alla betalningar till Part B:s butik inom 6 timmar och stoppa all utbetalning. Part A ska ha rätt att behandla återbetalningar för eventuella icke-kompatibla eller kränkande order, och alla kostnader och utgifter som uppstår därav ska enbart bäras av Part B. Det specifika bötesbeloppet visas i',
  theRefund: 'Återbetalningsgarantin inkluderar följande:',
  refundGuarantee: 'Villkor för återbetalningsgaranti.',
  priceList: 'Prislista',
  Holding: 'Innehav',
  appendixTwo: 'Bilaga 2.',
  paymentPriceList: 'Betalningsprislista',
  howDoes: 'Vad är Dropshipping och hur fungerar det',
  whatIsPayment: 'Vad är USAdrop Payment',
  differenceDropshipping: 'Skillnaden mellan Postförskott och Dropshipping',
  howsySterm: 'Hur man använder USAdrop systerm',
  howShopifyAPI: 'Hur man ställer in shopify API',
  howDomain: 'Hur man ställer in domän',
  howPixel: 'Så här konfigurerar du Facebook-pixeln',
  howCoupon: 'Hur man ställer in kupong',
  pleaseShopifyStore: 'Se till att domänen ansluter till din Shopify Store!',
  feeTerms: 'Avgiftsvillkor',
  noRefundGuarantee: 'Ingen återbetalningsgarantiavgift i Brasilien',
  deleteShopify:
    'Hur man tar bort eller lägger till "Köp nu" dynamisk knapp och "lägg i kundvagn"-knapp i Shopify',
  stepOne: 'Steg 1, navigera till "Onlinebutik" → "Teman" → "Anpassa"',
  stepTwo:
    'Steg 2 - Navigera till "Produkter" → "Standardprodukt" → gå till produktbeskrivningssidan',
  stepThree:
    'Steg 3 - Klicka på "Köpknappar" → Klicka för att aktivera "Visa dynamiska kassaknappar" → "Spara"',
  dynamicCheckoutButton: 'Hur man ställer in Dynamisk utcheckningsknapp',
  personalInformationTitle: 'Min kontoinformation',
  personalInformationSubTitle:
    'Verifiering av kontoinformation är en process för att säkerställa att din information är korrekt och uppdaterad. Det innebär att verifiera ditt telefonnummer för att säkerställa att det är korrekt och uppdaterat.',
  personalInformationTips: `Obs: 
För att säkerställa äktheten av din identitetsinformation måste vi verifiera ditt mobiltelefonnummer. Namnet och mobiltelefonnumret kan inte ändras efter verifiering och bindning. Om du inte kan få verifieringskoden eller behöver ändra den, vänligen kontakta USAdrop Payment kundtjänst/ombud.`,
  contactName: 'Kontaktnamn',
  contactPhone: 'Telefonnummer',
  contactPhoneAreaCode: 'Telefonens riktnummer',
  getVerificationCode: 'Hämta VERIFIKATIONSKOD',
  verificationCode: 'Verifieringskod',
  pleaseEnter: 'Vänligen ange {input}',
  pleaseSelect2: 'Välj {input}',
  fulfillmentPlatform: 'Uppfyllelseplattform',
  pleaseEnterCorrect: 'Vänligen ange korrekt {input}',
  sendSuccessfully: 'Skicka framgångsrikt',
  submitSuccessfully: 'Skicka framgångsrikt',
  serviceUnavailable: 'Tjänsten är inte tillgänglig',
  loginExpired: 'Inloggningen har löpt ut, vänligen logga in igen',
  toVerification: 'Till verifiering',
  activeCustomerPaymentTips:
    'Verifieringen av personuppgifter har inte slutförts ännu, så betaltjänsten kan inte användas.',
  activeCustomerPaymentTips2:
    'Klicka på "Verifiering av personlig information" för att slutföra verifieringen av personlig information.',
  skipCartTips1:
    'Den här funktionen hjälper till att öka konverteringsfrekvenserna för en enda beställning men minska antalet tillägg i kundvagnen. Aktivera det efter behov.',
  skipCartTips2: `När den är aktiverad kommer USAdrop Payment att inaktivera Shopifys "Lägg till i varukorgen" 
och behåll endast de dynamiska kassaknapparna. Kunder 
Om du klickar på dessa knappar kommer du direkt till kassan 
sida.`,
  skipCartTips3:
    '(Om kassaknappen inte är synlig på produktsidor efter att du har aktiverat den här funktionen, följ handledningen för att aktivera dynamiska kassaknappar:',
  advertisingMaterial: 'Handledning för reklammaterial',
  violationRecord: 'Överträdelseregister',
  store: 'Lagra',
  state: 'Ange',
  deadline: 'Tidsfrist',
  needModified: 'Behöver modifieras',
  reviewing: 'Granskning',
  completed: 'Avslutad',
  types: 'Typ',
  picture: 'Bild',
  details: 'Detaljer',
  overdue: 'Försenad',
  rejected: 'Avvisad',
  operate: 'Fungera',
  complete: 'Komplett',
  completeTips:
    'Vi är på väg att skicka in för granskning, se till att ändringarna har slutförts efter behov!',
  remark: 'Anmärkning',
  remarkPlaceholder: 'Vänligen ange anmärkning',
  pleaseInputRemark: 'Vänligen fyll i anmärkningen',
  facebookPixel: 'Hur ställer jag in Facebook Pixel?',
  googlePixel: 'Hur ställer jag in Google Pixel?',
  themeColor: 'Tema färg',
  themeColorTips:
    'Du kan använda den här inställningen för att ändra temafärgen för "checkout"-gränssnittet.',
  buttonColor: 'Köp nu Färg',
  buttonColorTips:
    'Du kan använda den här inställningen för att ändra färgen på knappen "Köp nu".',
  terminationAgreement: 'Uppsägning av avtal',
  installment: 'Avbetalning',
  unhandledStores: 'Du har illegala butiker',
  pixelTop1:
    'GTM är redan länkat. Du kan inte lägga till ytterligare en pixel.',
  pixelTop2: 'Stäng av den aktuella pixeln innan du använder GTM.',
  pixelTop3:
    'GTM och andra pixlar kan inte fungera samtidigt. Behöver du hjälp? Kontakta din agent.',
  successVideoTop: 'Verkliga framgångsberättelser',
  paypalTop: 'Kontakta vår agent för aktiv Paypal-betalning.',
  errorMessage: 'Serverfel uppstod',
  wiioRechargeTitle: 'Påminnelse',
  wiioRechargeDesc:
    'Vänligen betala månadsavgiften för att använda plattformen.',
  wiilRechargeConfirm: 'Gå till USAdrop',
  orderPageDesigner: 'Checkout-redigerare',
  export: 'Exportera',
  exporting: 'Exporterar...',
  unknownError: 'Okänt fel',
  downloadSuccess: 'Nedladdningen lyckades',
  defaultExportNotice:
    'Som standard kommer loggar från de senaste 30 dagarna att exporteras; du kan välja ett maximalt intervall på 30 dagar',
  pageStyleConfig: 'Sidstilskonfiguration',
  reset: 'Återställa',
  limitedTimeOffer:
    'Tidsbegränsat erbjudande! Beställ nu för att njuta av rabatten!',
  countdownToEnd: 'Tid tills evenemanget slutar:',
  configLoadedSuccess: 'Konfigurationsdata har lästs in',
  configLoadedUseDefault:
    'Det gick inte att läsa in konfigurationsdata med standardvärden',
  configLoadFailed:
    'Det gick inte att hämta konfigurationen, kontrollera nätverket eller tjänsten',
  confirmRestore:
    'Är du säker på att du vill återställa konfigurationen? Denna åtgärd är oåterkallelig',
  warning: 'Varning',
  confirmReset: 'Bekräfta återställning',
  submitSuccess: 'Skickades in',
  checkoutConfigSaved:
    'Konfigurationen av kassasidan har sparats och tillämpats framgångsrikt!',
  saveConfigFailed:
    'Det gick inte att spara konfigurationen, försök igen senare.',
  visualSizeConfig: 'Visuell och storlekskonfiguration',
  width: 'Bredd',
  height: 'Höjd',
  textAndCountdownConfig:
    'Konfiguration av text och nedräkning (marknadsföring)',
  textContent: 'Textinnehåll',
  enterMarketingCopy: 'Vänligen ange marknadsföringsexemplar',
  fontSize: 'Fontstorlek',
  fontColor: 'Teckensnittsfärg',
  fontWeight: 'Teckensnittsvikt',
  selectWeight: 'Välj vikt',
  countdownSettings: 'Nedräkningsinställningar',
  enableCountdown: 'Aktivera nedräkning',
  countdownPrefix: 'Nedräkningsprefix',
  examplePrefix: 'Exempel: Till slutet',
  endTime: 'Sluttid',
  selectEndTime: 'Välj sluttid för nedräkning',
  textSpacing: 'Text/timeravstånd',
  realtimePreview: 'Förhandsvisning i realtid',
  eventEnded: 'Evenemanget har avslutats',
  rowInfo: 'Rad {index} Information',
  icon: 'Ikon',
  title: 'Titel',
  bottomTextConfig: 'Nedre textkonfiguration',
  text: 'Text',
  suggestedSize: 'Föreslagen storlek',
  logo: 'Logotyp',
  banner: 'Baner',
  safetyInfo: 'Säkerhetsinformation',
  securityIcons: 'Säkerhet ikoner',
  description: 'Beskrivning',
  confirmSavePageStyle:
    'Är du säker på att du vill spara den aktuella sidstilskonfigurationen? När den har sparats träder den i kraft på kassasidan omedelbart.',
  getCodeTip: 'Fyll i Shop Domain, API Key och Secret Key först.',
  getCode: 'Få kod',
  token_helper_tip:
    'Få åtkomsttoken automatiskt via användaruppgifter för Dev Dashboard.',
  copySuccess: 'Kopierade!',
  paymentDetails: 'Betalningsuppgifter',
  viewPaymentCode: 'Betalningskod',
  paymentLink: 'Betalningslänk',
  paymentCodeDetails: 'Betalningskod',
  barcode: 'Streckkod',
  pixPaymentCode: 'PIX-betalningskod',
  copyPaymentCode: 'Kopiera betalningskod',
  downloadPaymentImage: 'Ladda ner bild',
  paymentCodeValidUntil: 'Giltig till',
  paymentImageUnavailable: 'Det gick inte att skapa betalningsbilden.',
  copyFailed: 'Det gick inte att kopiera. Markera och kopiera koden manuellt.',
  pleaseFillInClientIdAndSecret:
    'Vänligen fyll i Client ID (API Key) och Secret (API Secret Key)',
  pleaseEnterClientIdAndSecret:
    'Ange klient-ID (API-nyckel) och hemlig (API-hemlig nyckel)',
  pleaseFillInClientIdAndSecretFirst:
    'Fyll i klient-ID (API-nyckel) och hemlig (API-hemlig nyckel) först',
  pleaseContactAgent: 'Vänligen kontakta agenten',
  createStoreMexicoUSAdropPaymentsTitle: 'Bygg din Shopify-butik från 0',
  couponDisplayConfig: 'Kupongvisning',
  displayMode: 'Visningsläge',
  couponDisplayExpand: 'Expandera',
  couponDisplayHide: 'Dölja',
  couponHideModeTipStart:
    'När detta är aktiverat är fältet för kupongkod dolt som standard. Om du har konfigurerat en',
  couponHideModeTipEnd:
    'och den är aktiv, tillämpas den automatiskt när en kund lägger en andra beställning. Om du inte vill att kunder ska använda rabattkoder, ställ in kupongstatusen till "Inaktiverad".',
  couponDisplayCollapse: 'Kollapsa',
  couponUnselected: 'Avmarkerad',
  couponNoAvailable: 'Inga tillgängliga kuponger',
  couponNoCode: 'Behöver inte fyllas i',
  productPrice: 'Produkt',
  productDiscount: 'Rabatt',
  productShipping: 'Frakt',
  free: 'Gratis',
  apply: 'Tillämpas',
  orderPreviewPriceProduct: '9999,00 USD',
  orderPreviewPriceDiscount: '-0,00 USD',
  orderPreviewPriceTotal: '9999,00 USD',
  uponTransactionRisks:
    'När konsumenten lämnar in en begäran om återbetalning förbehåller sig part A rätten att behandla en återbetalning för transaktionen för att mildra mer allvarliga transaktionsrisker.',
  howGooglePixel: 'Så här konfigurerar du Google Pixel',
  fulfillmentPlatformTips: 'Viktigt: Beställningar som betalas via vår betalningslösning måste hanteras genom vår fulfillmenttjänst.',
  shippingCalculation: 'Aktivera beräkning av fraktkostnader',
  shippingCalculationTips: 'Beräkna och validera fraktkostnader i kassan.'
}
